const MenuItem = ({ icon, label = "menu" }) => {
  return (
    <span className="menu--item">
      {icon && icon}
      <span>{label}</span>
    </span>
  );
};

export default MenuItem;
